import { FC, Fragment, PropsWithChildren } from "react";
import clsx from "clsx";
import { map } from "lodash";
import { StepperProps } from "@/components/stepper/types";

import styles from "./styles.scss";
import { useCheckIfPersonnelsStepExist } from "@/hooks/use-check-if-personnels-step-exist";

const splitLine = (word: string): string => {
  if (!word) {
    return "";
  }

  return word.replace(" ", "\n");
};

export const Stepper: FC<PropsWithChildren<StepperProps>> = ({
  steps,
  activeStep,
}) => {
  const isPersonelStepExist = useCheckIfPersonnelsStepExist();

  const stepLength = steps.length ?? 1;
  const basis = `${Math.round(100 / (stepLength * 2))}%`;

  return (
    <div className={styles.stepperContainer}>
      {map(steps, (step, index) => (
        <Fragment key={`stepper-item-${index}`}>
          <div
            className={clsx(
              styles.stepperElement,
              index === 2 && !isPersonelStepExist && styles.disabled,
            )}
            style={{ flexBasis: basis }}
          >
            <div
              className={clsx(
                styles.stepperCircle,
                index <= activeStep && styles.circleActive,
              )}
            >
              {index + 1}
            </div>
            <div className={styles.stepperLabel}>{splitLine(step)}</div>
          </div>
          {index < stepLength - 1 && (
            <div style={{ flexBasis: basis }} className={styles.liga}></div>
          )}
        </Fragment>
      ))}
    </div>
  );
};
